import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const professionalEventValidator = yup.object().shape({
  name: yup.string().required(LOCALE.name + LOCALE.required_field),
  type: yup.object().shape({
    id: yup.string().required(LOCALE.type + LOCALE.required_field),
  }),
  role: yup.object().shape({
    id: yup.string().required(LOCALE.role + LOCALE.required_field),
  }),
  // date: yup.date().required(LOCALE.date + LOCALE.required_field),
  place: yup.string().required(LOCALE.place + LOCALE.required_field),
  proofs: yup.array().required(LOCALE.proof + LOCALE.required_field),
});

export const professionalEventPointsValidator = yup.object().shape({
  points: yup.string().required(LOCALE.name + LOCALE.points),
  pointsChecked: yup.boolean().oneOf([true], "Must Approve Points"),
});
